// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'coworking-card-frontend';

export const COWORKING_PATH_WITH_NAME = /[\w-]+-\d+\/?$/;

export const COWORKING_PATH = /\/coworking-\d+\/?$/;
